import React from 'react';

const InvitationFlowContext = React.createContext({});

export default InvitationFlowContext;
